export default __webpack_public_path__ + "static/media/logo.75ba8311.svg";